import { AxiosError } from 'axios'
import { parseYearQuarter } from 'utils'

import { GetPeopleSurveyedResponse } from 'api/actions/home/peopleSurveyed/peopleSurveyedActions.types'
import { Queries } from 'api/queries.enum'
import { getPeopleSurveyed } from 'api/actions/home/peopleSurveyed/peopleSurveyedActions'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { useQuery } from 'hooks/useQuery'
import { useSurveys } from 'hooks/useSurveys/useSurveys'

export const useGetPeopleSurveyed = () => {
    const { survey } = useSurveys()

    const params = {
        year: parseYearQuarter(survey),
    }

    const query = useQuery<GetPeopleSurveyedResponse, AxiosError>({
        queryKey: [Queries.getPeopleSurveyed, params],
        queryFn: () => getPeopleSurveyed(params),
        enabled: survey !== null,
        ...preventRefetchQueryOptions,
    })

    return query
}
